/** `{{ tag }}`, with any spaces inside the braces: the same rule the server renders with. */
const TAG = /\{\{\s*([^{}\s]+)\s*\}\}/g;

/** A template with sample values in place of its tags, for the live preview. */
export function renderPreview(text: string, samples: Record<string, string>): string {
  return text.replace(TAG, (_, name: string) => samples[name] ?? '');
}

// The GSM 03.38 alphabet a plain text message is sent in. Anything else (an
// emoji, a curly quote) switches the whole message to a wider encoding that
// fits fewer characters per SMS.
const GSM =
  '@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !"#¤%&\'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà';
const GSM_EXTENDED = '^{}\\[~]|€';

/** How long an SMS is, and how many messages it is sent as (each is charged). */
export function smsSegments(text: string): { chars: number; segments: number } {
  const chars = text.length;
  let gsmUnits = 0;
  let gsm = true;
  for (const c of text) {
    if (GSM.includes(c)) gsmUnits += 1;
    else if (GSM_EXTENDED.includes(c)) gsmUnits += 2;
    else {
      gsm = false;
      break;
    }
  }
  if (chars === 0) return { chars, segments: 0 };
  if (gsm) return { chars, segments: gsmUnits <= 160 ? 1 : Math.ceil(gsmUnits / 153) };
  return { chars, segments: chars <= 70 ? 1 : Math.ceil(chars / 67) };
}
